import { DEFAULT_LOCALE, DEFAULT_PARTNER } from "@pandas/core-ui";
import { redirect } from "@tanstack/react-router";
import type { RouterContext } from "../routes/__root";
import { hasDeviceInfo, hasStoreInfo } from "../store/guards";

type BeforeLoadContext = {
	context: RouterContext;
	location: { href: string; pathname: string };
	params: Record<string, string>;
};

async function checkAuth({ context, location }: BeforeLoadContext) {
	const { isAuthenticated, loginWithRedirect } = context.auth;
	if (!isAuthenticated) {
		loginWithRedirect({ appState: { returnTo: location.pathname } });
		return new Promise<never>(() => {});
	}
}

function checkStoreInfo({ params }: BeforeLoadContext) {
	if (!hasStoreInfo()) {
		const locale = params.locale ?? DEFAULT_LOCALE;
		const partner = params.partner ?? DEFAULT_PARTNER;
		throw redirect({ to: "/$locale/$partner/home", params: { locale, partner } });
	}
}

function checkDeviceInfo({ params }: BeforeLoadContext) {
	if (!hasDeviceInfo()) {
		const locale = params.locale ?? DEFAULT_LOCALE;
		const partner = params.partner ?? DEFAULT_PARTNER;
		throw redirect({ to: "/$locale/$partner/home", params: { locale, partner } });
	}
}

export async function requireAuthOnly(ctx: BeforeLoadContext) {
	await checkAuth(ctx);
}

export async function requireAuth(ctx: BeforeLoadContext) {
	await checkAuth(ctx);
	checkStoreInfo(ctx);
}

export async function requireAuthWithDevice(ctx: BeforeLoadContext) {
	await checkAuth(ctx);
	checkStoreInfo(ctx);
	checkDeviceInfo(ctx);
}
